import { render, staticRenderFns } from "./StrategySingle.vue?vue&type=template&id=0cd36a3e&"
import script from "./StrategySingle.vue?vue&type=script&lang=js&"
export * from "./StrategySingle.vue?vue&type=script&lang=js&"
import style0 from "./StrategySingle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports